// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18Kqe","left":"styles_left__378Fs"};